import { render, staticRenderFns } from "./InspectionItemScoreOverall.vue?vue&type=template&id=b3128fd0&"
import script from "./InspectionItemScoreOverall.vue?vue&type=script&lang=js&"
export * from "./InspectionItemScoreOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports